import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
export function addBaseMapToggle(baseMapSettings) {
    let basemap = new BasemapToggle({
        view: baseMapSettings.mapView,
        nextBasemap: baseMapSettings.esriBaseMapType, //'satellite' //customeBasemap,  //'satellite',
    });
    baseMapSettings.mapView.ui.add(basemap, baseMapSettings.basemapPosition);
    baseMapSettings.toggled == true ? basemap.toggle() : null;
    basemap.toggle();
    basemap.on('toggle', (event) => {
        baseMapSettings.callbackWhenToggled(event);
        //   let layer = getLayerByLayerId(mapView, "googleBaseMap");
        //   let googleStallite = getLayerByLayerId(mapView, "googleBaseMapStallite");
        // if (event.current.id == "basemapGoogleStallite") {
        //   //layer.visible = false;
        //   googleStallite.visible = true;
        // } else {
        //   //layer.visible = true;
        //   googleStallite.visible = false;
        // }
        // console.log("current basemap title: ", event.current);
        // console.log("previous basemap title: ", event.previous);
    });
}
